import { useEffect, useMemo, useState } from 'react';
import { Layout, Menu } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import './index.less';
import { menus } from '@/config';
import { permissionStore } from '@/store';

const { Sider } = Layout;
const { SubMenu } = Menu;
const Menus: React.FC = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [selectedKeys, setKelectedKeys] = useState<string[]>([
    '/rule-config',
    '/rule-config/rules',
  ]);
  const [openKeys, setOpenKeys] = useState<string[]>([]);
  const permissions = useRecoilValue(permissionStore);

  const hangleGo = (paths: string[]) => {
    setKelectedKeys(paths);
    const path = paths.pop() as string;
    navigate(path);
  };
  useEffect(() => {
    if (pathname) {
      const currentMenu = menus?.find(
        (m) => pathname.includes(m?.path) || m.path?.includes(pathname),
      );
      console.log(currentMenu, '===currentMenu');
      setKelectedKeys([currentMenu?.path || '', pathname]);
      if (currentMenu?.children && currentMenu?.children?.length > 0) {
        setOpenKeys([currentMenu.path]);
      } else {
        setOpenKeys([]);
      }
    }
    return;
    // if (pathname.includes('status')) {
    //   setKelectedKeys(['/oss-status/list']);
    //   setOpenKeys([]);
    // } else if (pathname.includes('rule-config')) {
    //   setKelectedKeys(['/rule-config', pathname]);
    //   setOpenKeys(['/rule-config']);
    // } else if (pathname.includes('oss-enterprise')) {
    //   setKelectedKeys(['/oss-enterprise', pathname]);
    //   setOpenKeys(['/oss-enterprise']);
    // } else if (pathname.includes('compony-set')) {
    //   setKelectedKeys(['/compony-set/index']);
    //   setOpenKeys(['/compony-set']);
    // } else if (pathname.includes('flex-group')) {
    //   setKelectedKeys(['/flex-group/list']);
    //   setOpenKeys(['/flex-group/list']);
    // } else if (pathname.includes('users-set')) {
    //   setKelectedKeys(['/users-set/list']);
    //   setOpenKeys(['/compony-set']);
    // } else if (pathname.includes('oss-mtbf')) {
    //   setKelectedKeys(['/oss-mtbf', pathname]);
    //   setOpenKeys([]);
    // } else if (pathname.includes('app-binding')) {
    //   setKelectedKeys(['/app-binding/list']);
    //   setOpenKeys([]);
    // } else if (pathname.includes('sla')) {
    //   setKelectedKeys(['/sla/list']);
    //   setOpenKeys([]);
    // }
  }, [pathname]);
  console.log(openKeys, 'openKeys');
  const handleOpenChange = (keys: string[]) => {
    setOpenKeys(keys);
  };

  const allmenus = useMemo(() => {
    if (permissions?.length > 0) {
      return menus?.filter((m) => permissions?.includes(m?.code || '') || !m?.code);
    } else {
      return [];
    }
  }, [menus, permissions]);

  return (
    <Sider width={200} className="site-layout-background">
      <Menu
        mode="inline"
        style={{ height: '100%', borderRight: 0 }}
        selectedKeys={selectedKeys}
        openKeys={openKeys}
        onOpenChange={handleOpenChange}
      >
        {allmenus.map((menu: MenuType) => {
          if (menu.children.length === 0) {
            return (
              <Menu.Item key={menu.path} onClick={() => hangleGo([menu.path])}>
                {menu.title}
              </Menu.Item>
            );
          } else {
            return (
              <SubMenu key={menu.path} title={menu.title}>
                {menu.children.map((m: MenuType) => {
                  return (
                    <Menu.Item key={m.path} onClick={() => hangleGo([menu.path, m.path])}>
                      {m.title}
                    </Menu.Item>
                  );
                })}
              </SubMenu>
            );
          }
        })}
      </Menu>
    </Sider>
  );
};

export default Menus;
